import styled from 'styled-components';

import { RichContent } from '~/src/common/components/CMS/RichText/layout';
import { BaseWaves } from '~/src/common/components/Logo';

export const Container = styled.section`
  display: flex;
  flex-direction: column;

  ${RichContent} {
    & > :first-child {
      margin-top: 0;
      padding-top: 0;
    }

    & > :last-child {
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Waves = styled(BaseWaves)`
  display: block;
  margin: 32px auto;
  color: ${({ theme }) => theme.palette.primary};
`;
